<template>
  <span class="tn-copyable">
    <code>{{ value || '—' }}</code>
    <v-btn v-if="value" icon x-small :aria-label="'Copy ' + label" @click="copy">
      <v-icon size="16">mdi-content-copy</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'CopyValue',
  props: {
    value: { type: [String, Number], default: null },
    label: { type: String, default: 'value' }
  },
  methods: {
    copy () {
      const notify = (color, text) => this.$root.$emit('tn-notify', { color, text })
      try {
        navigator.clipboard.writeText(String(this.value)).then(() => notify('success', 'Copied'), () => notify('error', 'Copy failed'))
      } catch (e) {
        notify('error', 'Copy failed')
      }
    }
  }
}
</script>
